const messages = {
  trade: {
    text1: "交易品种名称或代码",
    text2: "自选",
    text3: "品种",
    text4: "卖价",
    text5: "点差",
    text6: "最新价",
    text7: "买价",
    text8: "涨跌幅",
    text9: "已删除自选",
    text10: "已添加自选列表",
    text11: "最高",
    text12: "最低",
    text13: "报价",
    text14: "规则",
    text15: "分析",
    text16: "交易时间段 (UTC+8)",
    text17: "天",
    text18: "报价",
    text19: "实盘交易",
    text20: "多空分析",
    text21: "空",
    text22: "多",
    text23: "指标解读",
    text24: "分",
    text25: "时",
    text26: "天",
    text27: "周",
    text28: "1月",
    text29: "总结",
    text30: "买入",
    text31: "强烈买入",
    text32: "卖出",
    text33: "强烈卖出",
    text34: "中立",
    text35: "震荡指标",
    text36: "强烈",
    text37: "名称",
    text38: "数值",
    text39: "信号",
    text40: "移动平均线",
    text41: "名称",
    text42: "更多",
    text43: "枢轴点",
    text44: "经典",
    text45: "斐波那契",
    text46: "实盘账号",
    text46_1: "模拟账号",
    text47: "持仓",
    text48: "挂单",
    text49: "全部平仓",
    text50: "品种",
    text51: "类型",
    text52: "手数",
    text53: "开仓价格",
    text54: "最新价格",
    text55: "浮动盈亏",
    text56: "已用预付款",
    text57: "隔夜利息",
    text58: "止盈价格",
    text59: "止损价格",
    text60: "开仓时间",
    text61: "单号",
    text62: "操作",
    text63: "平仓",
    text64: "一键反手",
    text65: "止盈止损",
    text66: "暂无数据",
    text67: "登录",
    text68: "平仓品种",
    text69: "持仓手数",
    text70: "平仓手数",
    text71: "浮动盈亏",
    text72: "取消",
    text73: "确定",
    text74: "赠送品种已锁定，实名认证后可解锁",
    text75: "订单详情",
    text76: "平仓盈亏",
    text77: "平仓价格",
    text78: "交易返佣",
    text79: "隔夜利息",
    text80: "最少可平仓",
    text81: "手",
    text82: "最多可平仓",
    text83: "确定全部平仓吗？",
    text84: "好的",
    text85: "确定操作一键反手吗？",
    text86: "成功",
    text87: "挂单价格",
    text88: "预计占用",
    text89: "下单时间",
    text90: "截止时间",
    text91: "修改订单",
    text92: "撤单",
    text93: "修改订单",
    text94:
      "https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/icon_buy_red%402x.png",
    text94_green:
      "https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/icon_green_up_buy_cn.png",
    text94_blue:
      "https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/icon_blue_up_buy_cn.png",
    text95:
      "https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/icon_sell_green%402x.png",
    text95_green:
      "https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/icon_green_up_sell_cn.png",
    text95_blue:
      "https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/icon_green_up_sell_cn.png",
    text96: "价格",
    text97: "或",
    text98: "预计收益",
    text99: "预计亏损",
    text100: "挂单截止",
    text101: "请输入挂单价格",
    text102: "止损价格",
    text103: "止盈价格",
    text104: "未设置",
    text105: "挂单价格无效",
    text106: "挂单截止时间应大于目前最新时间",
    text107: "确定撤单吗？",
    text108: "实盘账号",
    text109: "余额",
    text110: "净值",
    text111: "浮动盈亏",
    text112: "可用预付款",
    text113: "已用预付款",
    text114: "信用赠金",
    text115: "预付款比例",
    text116: "类型",
    text117: "市价",
    text118: "挂单",
    text119: "交易手数",
    text120: "挂单价格",
    text121: "休市",
    text122: "请输入交易密码",
    text122_1: "请确认操作",
    text123: "交易品种",
    text124: "忘记密码",
    text125: "可用预付款不足",
    text126: "交易密码已被冻结",
    text127: "请重置交易密码",
    text128: "找回交易密码",
    text129: `交易手数不能小于`,
    text130: `交易手数不能大于`,
    text131: `请输入挂单价格`,
    text132: `需入金后才能使用赠金交易`,
    text133: `止盈止损`,
    text134: `平仓时间`,
    text135: `1分`,
    text136: `5分`,
    text137: `15分`,
    text138: `30分`,
    text139: `1时`,
    text140: `4时`,
    text141: `日K`,
    text142: `周K`,
    text143: `月K`,
    text144: `下单确认`,
    text145: `买`,
    text146: `卖`,
    text147: `一键交易`,
    text148: `模拟交易已到期`,
    text149: "部分平仓",
    text150: "快速交易开启成功",
    text151: "点击展开",
    text152:
      "https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/icon_zk_right.png",
    text153:
      "https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/icon_sq_right.png",
    text154:
      "https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/icon_zk_left.png",
    text155:
      "https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/icon_sq_left.png",
    text156: "模拟交易",
    text157: "您将要激活快速交易模式。通过点击下面的“我接受这些合同条款”，您会承认您已经阅读并理解以下合同条款，您同意特此遵守。您当前的程序端版本使您在下面的订单提交模式间选择。您同意遵守本规定的条款和条件，有关这样的模式。",
    text158: "1.订单提交的默认模式是两步处理法。使用默认模式，您先调用一个新订单窗口。然后您需要选择一个合适的订单类型，它的参数并且根据您选定的具体订单类型和您的交易意愿，通过点击买入，卖出，下单，更改或关闭按钮，确认您订单的提交。使用默认模式，您的订单将直到您完成前面提到的两个步骤才会提交。",
    text159: `2.订单提交的快速交易模式（“快速交易”）是一步处理法。使用快速交易模式，您的订单将会被提交当您：`,
    text160: `图表上单击卖(SELL)或买(BUY)价格按钮时：`,
    text161: `在网页端窗口的交易标签上删除挂单`,
    text162: `不会有后续确认提示您点击。一旦您点击，您将无法撤销或更改您的订单。在正常市场条件和系统性能下，提交后市场订单会立即填写并且您将会输入一个绑定交易。`,
    text163: `您可以在网页端选项窗口的交易标签上激活或停用单击交易模式。`,
    text164: `通过选择快速交易模式，您了解到您的订单将根据您点击卖或买价进行提交，没有后续订单确认。您同意接受与使用您选定的订单提交模式相关的全部风险，包括，但不限于，过失风险，提交订单时发生的失误。`,
    text165: `您同意完全赔偿和使DayDayTrade在由您，您的交易经理或任何代表您进行交易的人，造成的任何错误遗漏或失误而导致的结果引起的各种损失，成本和费用上免受损失。`,
    text166: '我接受以上合同条款',
    text167: '免责声明',
    text168: '涨跌颜色',
    text169: '红涨',
    text170: '绿跌',
    text171: '绿涨',
    text172: '红跌',
    text173: '蓝涨',
    text174: '快速交易',
    text175: '开启',
    text176: '关闭',
  },
  signUp: {
    text1: "立即注册",
    text2: "开启您的投资之旅",
    text3: "支持跟单交易 — 与顶级交易者分享利润",
    text4: "资金安全 — 安全、快速存取款",
    text5: "用户友好 — 满足不同阶段的投资者需求",
    text6: "免费资源 — 优秀的交易策略、行情分析，1对1入门指导",
    text7: "手机号验证码登录",
    text8: "新用户可直接注册登录",
    text9: "手机号",
    text10: "邮箱",
    text11: "点击按钮即表示您同意并遵循",
    text12: "《Day Day Trade 用户协议》",
    text13: "请输入手机号码",
    text14: "选择国家/地区",
    text15: "请输入验证码",
    text16: "获取验证码",
    text17: "重新发送",
    text18: "正在发送",
    text19: "发送成功",
    text20: "请输入您的手机号",
    text21: "登录成功",
    text22: "注册/登录",
    text22_1: "登录",
    text23: "账号密码登录",
    text24: "手机号验证码登录/注册",
    text25: "忘记密码",
    text26: "请输入邮箱",
    text27: "请输入密码",
    text28: "手机号",
    text29: "邮箱",
    text30: "设置登录密码",
    text31: "请输入8-15位数字字母组合密码",
    text32: "请再次确认密码",
    text33: "密码不匹配",
    text34: "跳过",
    text35: "确定",
    text36: "设置成功",
    text37: "请输入8-15位数字字母组合密码",
    text38: "登录/注册",
    text39: "两次输入的密码不一致，请重新输入",
    text40: "密码重置成功",
    text41: "请输入验证码",
    text42: "请输入电子邮箱",
    text43: "邮箱格式错误",
    text44: "验证码错误",
    text45: "暂无权限，请联系客服",
    text46: "验证码登录",
  },
  components: {
    text1: "修改交易密码",
    text2: "输入6位数字的密码",
    text3: "请输入6位数字的密码",
    text4: "交易密码不能为6位重复",
    text5: "交易密码为6位",
    text6: "交易密码不能为连续6位数字",
    text7: "修改成功",
    text8: "设置交易密码",
    text9: "交易密码不能重复或连续6位",
    text10: "请确认密码",
    text11: "解绑",
    text12: "选择银行卡",
    text13: "绑定邮箱",
    text14: "请输入手机验证码",
    text15: "下一步",
    text16: "请输入邮箱地址",
    text17: "请输入邮箱验证码",
    text18: "邮箱绑定成功",
    text19: "绑定手机号成功",
    text20: "绑定手机号",

  },
  myAccount: {
    text1: "账户中心",
    text2: "账户资产",
    text3: "历史交易",
    text4: "入金",
    text5: "出金",
    text6: "资金流水",
    text7: "资金记录",
    text8: "资金划拨",
    text9: "基础信息",
    text10: "头像",
    text11: "修改",
    text12: "昵称",
    text13: "DayDayTrade账户",
    text14: "手机号码",
    text15: "实名认证",
    text16: "地址证明",
    text17: "未提交",
    text18: "审核中",
    text19: "地址认证错误",
    text20: "MT5实盘账号",
    text21: "个人资料",
    text22: "提交",
    text23: "编辑",
    text24: "邮箱",
    text25: "解绑",
    text26: "绑定",
    text27: "安全中心",
    text28: "登录密码",
    text29: "设置",
    text30: "MT5实盘账号密码",
    text31: "重置",
    text32: "交易密码",
    text33: "银行账户",
    text34: "添加",
    text35: "出金地址",
    text36: "删除",
    text37: "未实名",
    text38: "已实名",
    text39: "身份认证失败",
    text40: "上传",
    text41: "签名无效",
    text42: "地址认证失败",
    text43: "未上传证件",
    text44: "未提交签名",
    text45: "待上传手持证件照",
    text46: "手持证件照错误",
    text47: "确认解除绑定邮箱",
    text47_1: "确认解除绑定手机号？",
    text48: "邮箱解绑成功",
    text48_1: "手机号解绑成功",
    text49: "MT5 实盘密码每天只能重置一次",
    text50: "解除绑定您的",
    text51: "卡，尾号为",
    text52: "解绑成功",
    text53: "删除出金地址？",
    text54: "地址删除成功",
    text55: "根据DayDayTrade合规体系规定，您需要补充地址证明资料",
    text56: "补充资料",
    text57: "您的地址证明未通过验证，请重新提交",
    text58: "附上文件",
    text59: "* 个人资料的完善便于系统进行风险提醒，请认真填写",
    text60: "家庭成员数",
    text61: "人",
    text62: "人",
    text63: "人及以上",
    text64: "婚姻状况",
    text65: "已婚",
    text66: "未婚",
    text67: "离异",
    text68: "丧偶",
    text69: "职业状况",
    text70: "在职",
    text71: "无业",
    text72: "学生",
    text73: "退休",
    text74: "选择行业",
    text75: "金融/银行/保险",
    text76: "政府/事业机构",
    text77: "广告公关/媒体/艺术文化",
    text78: "销售/贸易",
    text79: "计算机/互联网/通信/电子技术",
    text80: "生产制造/物流运输",
    text81: "医药/化工",
    text82: "建筑/房地产",
    text83: "教育/法律",
    text84: "餐饮/娱乐/美容",
    text85: "其他",
    text86: "总资产净值",
    text87: "投资目标",
    text88: "投资经验",
    text89: "",
    text90: "资产增值",
    text91: "投机",
    text92: "套利",
    text93: "对冲",
    text94: "年以下",
    text95: "年",
    text96: "",
    text96_1: "以上",
    text97: "成功",
    text98: "修改头像",
    text99: "头像",
    text100: "更新头像",
    text101: "修改成功",
    text102: "昵称长度不能超过15个字符",
    text103: "请输入",
    text104: "登录密码",
    text105: "修改登录密码",
    text106: "请输入原密码",
    text107: "登录密码重置成功",
    text108: "重置MT5实盘密码",
    text109: "* 新MT5密码将发送至您手机",
    text110: "添加银行账户信息",
    text111: "银行账户姓名",
    text112: "币种",
    text113: "银行名称",
    text114: "银行账户号",
    text115: "银行代码",
    text116: "开户银行地址",
    text117: "请输入",
    text118: "保存",
    text119: "请选择该通道可用的银行卡",
    text120: "银行卡添加成功",
    text121: "选择银行名称",
    text122: "添加出金地址",
    text123: "备注",
    text124: "不超过10个字符",
    text125: "出金地址添加成功",
    text126: "请选择",
    text127: "修改昵称",
    text128: "添加银行账户信息",
    text129: "银行代码",
    text130: "选择或输入银行名称",
    text131: "选择出金地址",
    text132: "查看",
    text133: "高于",
    text134: "10万美元以下",
    text135: "10万美元—20万美元",
    text136: "20万美元—30万美元",
    text137: "30万美元—50万美元",
    text138: "50万美元—100万美元",
    text139: "100万美元—500万美元",
    text140: "500万美元—1000万美元",
    text141: "1000万美元以上",
    text142: "MT4实盘账号",
    text143: "MT4实盘账号密码",
    text144: "MT4 实盘密码每天只能重置一次",
    text145: "重置MT4实盘密码",
    text146: "* 新MT4密码将发送至您手机",
    text147: "请输入银行名称",
    text148: "了解详情",
    text149: "立即认证",
    text150: "个人信息",
    text151: "我的账户",
    text152: "认证状态",
    text153: "认证步骤",
    text154: "Web账户",
    text155: "MT4账户",
    text156: "新增账号",
    text157: "确认新增账号吗？",
    text158: "确认",
    text159: "取消",
    text160: "知道了",
    text161: "新增失败，账号不得多于5个",
    text162: "新增账号失败",
    text163: "MT4账号新增失败",
    text164: "好的",
    text165: "实名认证步骤",
    text166: "填写基本信息",
    text167: "上传身份认证资料",
    text168: "邮箱验证",
    text169: "手机号验证",
    text170: "已完成",
    text171: "步",
    text172: "杠杆调整",
    text173: "MT4杠杆调整",
    text174: "选择",
    text175: "杠杆比例",
    text176: "全部",
    text177: "确认调至",
    text178: "倍杠杆？",
    text179: "软件下载",
    text180: "下载MT4 PC版",
    text181: "点击可下载",
    text182: "下载MT4 APP",
    text183: "MT4账号的杠杆调整申请已提交成功，审核结果将通过短信/邮箱发送",
  },
  AccountAssets: {
    text1: "实盘账户",
    text2: "账户资产",
    text3: "净值",
    text4: "余额",
    text5: "浮动盈亏",
    text6: "信用赠金",
    text7: "可用预付款",
    text8: "已用预付款",
    text9: "预付款比例",
    text10: "总平仓盈亏",
    text11: "总返佣",
    text12: "总入金",
    text13: "总出金",
    text14: "交易品种",
    text15: "下单时间",
    text16: "全部",
    text17: "开始时间",
    text18: "结束时间",
    text19: "查询",
    text20: "数据统计",
    text21: "总隔夜利息",
    text22: "总平仓手数",
    text23: "总平仓订单数",
    text24: "已平仓",
    text25: "已撤单",
    text26: "国家",
    text27: "姓氏",
    text28: "名字",
    text29: "生日",
    text30: "详细地址",
    text31: "身份证号",
    text32: "认证成功后即可交易，坐享收益",
    text33: "确认退出验证?",
    text34: "继续验证",
    text35: "实名认证",
    text36: "基本资料",
    text37: "身份验证",
    text38: "协议确认",
    text39: "开户文件",
    text40: "身份证明",
    text41:
      "带有头像和有效期的身份证明文件，例如：身份证、护照、驾照以及政府颁发的其他有效证明等",
    text42: "必传",
    text43: "地址证明",
    text44:
      "过去六个月内的水、电、煤气、信用卡纸质账单等，建议提交银行账单的pdf文件",
    text45: "非必传",
    text46: "文件示例",
    text47: "正确示例",
    text48: "",
    text49: "信息模糊",
    text50: "",
    text51: "边角缺失",
    text52: "",
    text53: "请确认已阅读并同意以下协议",
    text54: "《用户协议》",
    text55: "《税务表格》",
    text56: "《附件I 利益冲突》",
    text57: "《附件II 风险提示书》",
    text58: "《附件III 最佳执行策略》",
    text59: "请确认以下声明",
    text60: "我是本账户的最终受益人",
    text61: "我不是美国公民或就税务而言的公民",
    text62: "我不是DayDayTrade代理人或与职员有亲属关系",
    text63:
      "本人提供的所有开户信息均为真实准确，并同意在内容有变化的情况下，以电话或者邮箱的形式通知DayDayTrade，必要时本人授权DayDayTrade对资料的准确性进行确认，签名后表示您阅读并理解风险提示书中的内容。",
    text64: `开户审核中`,
    text65: `您的资料已提交审核，等待1-2个工作日进行审核，审核成功后，我们将通知联系您，请您保持联系。`,
    text66: `时间`,
    text67: `总赠金`,
    text68: `总划拨`,
    text69: `金额`,
    text70: `划拨类型`,
    text71: `划拨金额`,
    text72: `可划拨金额`,
    text73: `实名认证`,
    text74: `* 您的资料提交我们已收到，鉴于DayDayTrade合规体系的规定，为防止其他人恶意使用您的身份，您需要上传您的手持证件照`,
    text75: `请上传您的手持身份证`,
    text76: `请上传您的手持身份证正面照片`,
    text77: `头像和文字清晰，无明显反光`,
    text78: `整个头部和身份证的四个角和边框都在拍摄区域`,
    text79: `示例`,
    text80: `取消`,
    text81: `提交`,
    text82: `我已阅读全文，了解风险并愿意继续在DayDayTrade开户`,
    text83: `清空`,
    text84: `请输入手写签名`,
    text85: `超龄用户风险协议`,
    text86: `* 根据DayDayTrade合规体系规定，您需要补充地址证明资料`,
    text87: `* 您提交的地址证明资料未通过审核，请重新上传提交`,
    text88: `地址证明`,
    text89: `地址证明审核中`,
    text90: `Web实盘账户`,
    text91: `Web模拟盘账户`,
    text92: `MT4实盘账户`,
    text93: `MT4模拟盘账户`,
    text94: `划出`,
    text95: `划入`,
    text96: `需实名认证通过后才可新增MT4账号`,
    text97: `订单`,
    text98: `下单时间`,
    text99: `类型`,
    text100: `手数`,
    text101: `交易品种`,
    text102: `开仓价格`,
    text103: `止损价格`,
    text104: `止盈价格`,
    text105: `平仓时间`,
    text106: `平仓价格`,
    text107: `手续费`,
    text108: `库存费`,
    text109: `平仓盈亏`,
    text110: `MT4账号`,
    text111: `web账号`,
    text112: `总手续费`
  },
  fundHistory: {
    text1: "入金",
    text2: "出金",
    text3: "赠金",
    text4: "返佣",
    text5: "划拨",
    text6: "入金类型",
    text7: "订单状态",
    text8: "时间",
    text9: "状态",
    text10: "入金金额",
    text11: "时间",
    text12: "操作",
    text13: "详情",
    text14: "状态",
    text15: "币种",
    text16: "入金金额",
    text17: "支付金额",
    text18: "上链时间",
    text19: "到账时间",
    text20: "点击钱包地址或TxHash可以在浏览器查看链上记录",
    text21: "地址",
    text22: "订单已确认付款，等待资金到账",
    text23: "",
    text24: " 后订单失效，请尽快汇款并确认已付款操作",
    text25: "购买数量",
    text26: "支付金额",
    text27: "支付方式",
    text28: "收款账号",
    text29: "收款人",
    text30: "取消订单",
    text31: "确认已付款",
    text32: "确认取消订单？",
    text33: "订单取消成功",
    text34: "订单确认已完成付款?",
    text35: "订单确认成功",
    text36: "正在加载",
    text37: "出金类型",
    text38: "出金金额",
    text39: "预计到账",
    text40: "手续费",
    text41: "撤销",
    text42: "到账金额",
    text43: "手续费",
    text44: "收款银行",
    text45: "确定是否撤销该笔出金订单？",
    text46: "撤销成功",
    text47: "赠金类型",
    text48: "类型",
    text49: "佣金类型",
    text50: "总佣金",
    text51: "交易手数",
    text52: "交易时间",
    text53: "划拨金额",
    text54: "划拨方向",
    text55: "时间",
    text56: "最低划拨",
    text57: "可划拨金额不足",
    text58: "提交成功",
  },
  deposit: {
    text1: "选择支付币种",
    text2:
      "* 请选择您要支付的币种，我们将根据您选择的付款币种提供相应的支付通道。",
    text3: "操作汇款",
    text4: "上传凭证",
    text5: "完成",
    text6: "收款信息",
    text7: "展开",
    text8: "收款人姓名",
    text9: "收款人地区",
    text10: "汇款信息",
    text11: "汇款银行",
    text12: "汇款金额",
    text13: "汇款凭证",
    text14: "*上传图片大小不得大于4M",
    text15: "收款信息",
    text16: "收款人姓名",
    text17: "收款人地区",
    text18: "收款人地址",
    text19: "收款人银行",
    text20: "收款账号",
    text21: "收款行地址",
    text22: "SWIFT代码:",
    text23: "复制全部信息",
    text24: "复制成功",
    text25: "入金金额不能少于",
    text26: "银行对账无误后金额会自动到账，一般需要1个工作日左右，请耐心等待。",
    text27: `选择币种`,
    text28: `链名称`,
    text29: `当前汇率`,
    text30: `入金金额`,
    text31: `预计支付金额`,
    text32: `请输入金额`,
    text33: `您的个人多重签名`,
    text34: `入金地址`,
    text35: `单笔限制 `,
    text36: `最多 `,
    text37: `最少 `,
    text38: `选择通道`,
    text39: `入金金额`,
    text40: `其他`,
    text41: `手续费`,
    text42: `支付金额`,
    text43: `汇率`,
    text44: `所属国家`,
    text45: `银行`,
    text46: `确定`,
    text47: `注意事项:`,
    text48: `综合汇率`,
    text49: `购买数量`,
    text50: `实名认证`,
    text51: `* 支付金额为预估金额，请按照实际生成订单中的金额支付`,
    text52: `未完成订单`,
    text53: ``,
    text54: `后订单失效，请尽快汇款并确认已付款操作`,
    text55: `订单已确认付款，等待资金到账`,
    text56: `状态`,
    text57: `支付方式`,
    text58: `入金金额`,
    text59: `收款账号`,
    text60: `复制`,
    text61: `收款人`,
    text62: `时间`,
    text63: `取消订单`,
    text64: `确认已付款`,
    text65: `存在未支付订单，发起新订单失败`,
    text66: `确认已付款`,
    text67: `取消`,
    text68: `确认取消订单？`,
    text69: `订单取消成功`,
    text70: `订单确认已付款？`,
    text71: `分`,
    text72: `秒`,
    text73: `入金页面错误`,
  },
  withdraw: {
    text1: `选择通道`,
    text2: `当前汇率`,
    text3: `可提金额`,
    text4: `出金金额`,
    text5: `预计收款`,
    text6: `全部`,
    text7: `实名认证`,
    text8: `收款银行卡`,
    text9: `添加银行卡`,
    text10: `切换其他已绑银行卡`,
    text11: `* 预计收款金额为预估金额，实际收款以到账金额为准`,
    text12: `确定`,
    text13: `最近一笔订单`,
    text14: `状态`,
    text15: `收款银行`,
    text16: `出金金额`,
    text17: `收款账号`,
    text18: `预计到账`,
    text19: `收款人`,
    text20: `时间`,
    text21: `撤销`,
    text22: `正在加载`,
    text23: `单笔限制`,
    text24: `最多 `,
    text25: `最少 `,
    text26: `风险提示`,
    text27: `出金`,
    text28: `取消`,
    text29: `提交成功`,
    text30: `复制成功`,
    text31: `确认是否撤销该笔出金订单`,
    text32: `好的`,
    text33: `可提金额 = 净值 - 信用赠金 - 余额赠金 - 待打款订单金额`,
    text34: `对于持仓客户:可提金额 = 净值 - 信用赠金 - 余额赠金-待打款订单金额- 已用保证金/杠杆比例 X2%(2%是我们对您的持仓订单最大亏损的一个估值，为保证提现后不影响您当前的持仓)`,
    text35: ``,
    text36: ``,
    text37: `可提金额说明`,
    text38: `选择收款币种`,
    text39: `*请选择您要接收的货币，我们将根据您选择的货币提供相应的出金通道。`,
    text40: `收款币种`,
    text41: `预计到账金额`,
    text42: `汇率`,
    text43: `银行账户信息`,
    text44: `可用银行`,
    text45: `开户姓名`,
    text46: `银行名称`,
    text47: `银行地址`,
    text48: `银行账户号`,
    text49: `SWIFT代码`,
    text50: `请填写补充信息`,
    text51: `使用该通道出金请使用以下银行收款`,
    text52: `该通道不支持使用此银行收款`,
    text53: `请选择`,
    text54: `添加`,
    text55: `银行代码`,
    text56: `选择币种`,
    text57: `链名称`,
    text58: `可提金额`,
    text59: `手续费`,
    text60: `出金地址`,
    text61: `选择或输入地址`,
    text62: `选择`,
    text63: `预计扣除`,
    text64: `*预计收款金额为预估金额，实际收款金额以到账金额为准`,
    text65: `可提金额说明`,
    text66: `*无持仓用户`,
    text67: `可提金额 = 净值-信用赠金-余额赠金-待打款订单金额`,
    text68: `*有持仓用户`,
    text69: `可提金额 = 净值-信用赠金-余额赠金-待打款订单金额-已用保证金/杠杆比例*1%`,
    text70: `(1%是我们对您的持仓订单最大亏损的一个估值，为保证提现后不影响您当前的持仓 )`,
    text71: "安全验证",
    text72: "*为保证您链上的资金安全，需要对您的账户进行安全验证",
    text73: "提币金额错误，不能大于当前可提币金额",
    text74: "账号",
  },
  proxy: {
    text1: "代理系统",
    text2: "系统首页",
    text3: "首页",
    text4: "数据汇总条件",
    text5: "查看范围",
    text6: "我的客户",
    text7: "代理客户",
    text8: "时间段",
    text9: "今年",
    text10: "本月",
    text11: "本周",
    text12: "今天",
    text13: "搜索",
    text14: "数据总览",
    text15: "代理数（人）",
    text16: "注册数（人）",
    text17: "开户数（人）",
    text18: "当前可提返佣",
    text19: "总交易量（手数）",
    text20: "总返佣（美元）",
    text21: "净入金（美元）",
    text22: "总入金（美元）",
    text23: "总出金（美元）",
    text24: "个人信息",
    text25: "代理信息",
    text26: "名称",
    text27: "联系人",
    text28: "联系电话",
    text29: "H5注册链接",
    text30: "复制",
    text31: "H5注册二维码",
    text32: "保存二维码",
    text33: "姓名",
    text34: "邮箱",
    text35: "身份证号",
    text36: "联系地址",
    text37: "MT5实盘账号",
    text38: "MT5模拟账号",
    text39: "web账号",
    text40: "返佣规则组",
    text41: "规则组名称",
    text42: "添加返佣规则",
    text43: "设置为模板",
    text44: "是",
    text45: "否",
    text46: "状态",
    text47: "正常",
    text48: "禁用",
    text49: "品种返佣配置",
    text50: "引入返佣规则模板",
    text51: "引入默认设置",
    text52: "序号",
    text53: "可支配返佣",
    text54: "剩余返点",
    text55: "下级返佣",
    text56: "下级返佣比例",
    text57: "返佣规则组名称",
    text58: "是否设为模板",
    text59: "最后修改时间",
    text60: "无数据",
    text61: "代理管理",
    text62: "代理名称",
    text63: "添加时间",
    text64: "新增代理",
    text65: "代理ID",
    text66: "用户数量",
    text67: "开户数量",
    text68: "编辑",
    text69: "代理基本信息",
    text70: "简名称",
    text71: "站点名称",
    text72: "例如",
    text73: "网址",
    text74: "代理微信",
    text75: "代理QQ",
    text76: "备注",
    text77: "客户管理",
    text78: "开户状态",
    text79: "未认证",
    text80: "认证中",
    text81: "已认证",
    text82: "审核未通过",
    text83: "注册时间",
    text84: "用户ID",
    text85: "交易数据",
    text86: "交易历史",
    text87: "交易品种",
    text88: "客户姓名",
    text89: "手机号",
    text90: "MT5账号",
    text91: "重置",
    text92: "展开",
    text93: "收起",
    text94: "买卖方向",
    text95: "全部",
    text96: "买入",
    text97: "卖出",
    text98: "交易状态",
    text99: "已平仓",
    text100: "未平仓",
    text101: "平仓类型",
    text102: "用户操作",
    text103: "系统操作",
    text104: "止盈平仓",
    text105: "止损平仓",
    text106: "到达平仓时间",
    text107: "风控强平",
    text108: "跟随平仓",
    text109: "跟随开仓",
    text110: "用户自主开仓",
    text111: "web账号",
    text112: "交易账号",
    text113: "开仓日期",
    text114: "平仓日期",
    text115: "平仓盈亏",
    text116: "隔夜利息",
    text117: "总交易返佣",
    text118: "交易手数",
    text119: "导出本页",
    text120: "导出全部",
    text121: "白标",
    text122: "代理",
    text123: "MT5开仓订单号",
    text124: "MT5平仓订单号",
    text125: "开仓价格",
    text126: "平仓价格",
    text127: "止盈",
    text128: "止损",
    text129: "交易账号",
    text130: "Web余额",
    text131: "Web净值",
    text132: "Web预付款比例",
    text133: "MT5余额",
    text134: "MT5净值",
    text135: "MT5预付款比例",
    text136: "净入金",
    text137: "净佣金",
    text138: "规则组",
    text139: "操作",
    text140: "查看持仓",
    text141: "持仓列表",
    text142: "浮动盈亏合计",
    text143: "隔夜利息合计",
    text144: "订单号",
    text145: "MT5订单号",
    text146: "最新价",
    text147: "已用保证金",
    text148: "浮动盈亏",
    text149: "隔夜利息",
    text150: "财务结算",
    text151: "佣金提取",
    text152: "接受账户",
    text153: "状态",
    text154: "审核中",
    text155: "到账中",
    text156: "已拒绝",
    text157: "已到账",
    text158: "申请时间",
    text159: "累计产生佣金",
    text160: "可提佣金",
    text161: "已提取佣金",
    text162: "提取佣金",
    text163: "申请Id",
    text164: "提取金额",
    text165: "接受账号",
    text166: "提交",
    text167: "取消",
    text168: "佣金申请",
    text169: "开仓类型",
    text170: "跟随交易员",
    text171: "请选择",
    text172: "申请金额大于可提佣金余额！",
    text173: "申请金额需大于零！请重新输入",
    text174: "处理中",
    text175: "提交申请成功！",
    text176: "申请失败",
    text177: "必填项不能为空",
    text178: "启用",
    text179: "禁用",
    text180: "绑定开户账户",
    text181: "注：请先去app开户，绑定app开户账号",
    text182: "下一步",
    text183: "用户登录代理后台系统账号",
    text184: "为代理创建后台登录账号",
    text185: "查看完整手机号",
    text186: "操作成功",
    text187: "操作失败",
    text188: "确定导出所有数据？",
    text189: "存在重复品种！",
    text190: "账户管理",
    text191: "自主开仓",
    text192: "跟随开仓",
    text193: "Web交易端",
    text194: "MT5交易端",
    text195: "代理账户",
    text196: "返佣账户",
    text197: "跟单收入",
    text198: "启用",
    text199: "禁用",
    text200: "数据查询条件",
    text201: "开始时间",
    text202: "结束时间",
    text203: "总交易返佣（USD）",
    text204: "可提返佣（USD）",
    text205: "净入金（USD）",
    text206: "期初实盘净值（USD）",
    text207: "期初跟单净值（USD）",
    text208: "期末实盘净值（USD）",
    text209: "期末跟单净值（USD）",
    text210: "趋势分析",
    text211: "推广链接",
    text212: "等级",
    text213: "二维码",
    text214: "查看",
    text215: "复制失败",
    text216: "MT4账号",
    text217: "Web交易持仓",
    text218: "MT4交易持仓",
    text219: "持仓量",
    text220: "持仓价格",
    text221: "Web开仓订单号",
    text222: "Web平仓订单号",
    text223: "止盈价格",
    text224: "止损价格",
    text225: "低点差",
    text226: "普通点差",
    text227: "高点差",
    text228: "交易品种配置",
    text229: "交易规则组",
    text230: "规则组名称",
    text231: "警告比例",
    text232: "强平比例",
    text233: "固定点差",
    text234: "交易品种配置",
    text235: "引入规则组模板",
    text236: "最低点差",
    text237: "买价加点",
    text238: "卖价加点",
    text239: "交易点差",
    text240: "可支配返点",
    text241: "返点比例",
    text242: "请选择规则组模板",
    text243: "保存成功",
    text244: "保存失败",
    text245: "获取模板失败",
    text246: "应用模板失败",
    text247: "规则组ID",
    text248: "规则组状态",
    text249: "添加下级规则组",
    text250: "查看下级规则组",
    text251: "获取规则组数据失败",
    text252: "获取下级规则组失败",
    text253: "出入金类型",
    text254: "金额（币种）",
    text255: "金额",
    text256: "退出登录",
    text257: "所属代理",
    text258: "国际区号",
    text259: "创建时间",
    text260: "查看账户",
    text261: "累计佣金",
    text262: "接收账号类型",
    text263: "接收账号",
    text264: "累计佣金",
    text265: "申请提取金额",
    text266: "用户状态",
    text267: "联系人电话",
    text268: "注：请先去app开户，绑定用户ID",
    text269: "低点差规则组",
    text270: "普通点差规则组",
    text271: "高点差规则组",
    text272: "绑定用户ID",
    text273: "编辑代理",
    text274: "MT4余额",
    text275: "MT4净值",
    text276: "MT4预付款比例",
    text277: "Web交易历史",
    text278: "MT4交易历史",
    text279: "规则组模板",
    text280: "交易员账户",
    text281: "资金管理",
    text282: "代理列表",
    text283: "客户列表",
    text284: "交易账户",
    text285: "出入金列表",
    text286: "请完整填写提现信息",
    text287: "时间范围",
    text288: "提取金额不能低于0.01 USD",
    text289: "角色",
    text290: "请输入正确的用户ID",
    text291: "返点不能大于可支配返点",
    text292: "库存费",
    text293: "待审核",
    text294: "划拨成功",
    text295: "划拨失败",
    text296: "划拨异常",
    text297: "划拨中",
    text298: "下级规则组",
    text299: "编辑规则组",
    text300: "添加规则组",
    text301: "代理",
    text302: "净值总览",
    text303: "手续费返佣不能大于可支配手续费",
    text304: "返点",
    text305: "可支配手续费",
    text306: "剩余手续费",
    text307: "手续费返佣",
    text308: "手续费返佣比例",
    text309: "总返佣",
    text310: "总手续费返佣",
    text311: "查看当前规则组",
    text312: "规则组至少选择1个",
  },
  followOrder: {
    text1: "跟单交易系统",
    text2: "账户管理",
    text3: "个人信息",
    text4: "昵称",
    text5: "姓名",
    text6: "手机号",
    text7: "web账号",
    text8: "身份",
    text9: "数据统计",
    text10: "交易单数",
    text11: "交易手数",
    text12: "月平均交易单数",
    text13: "多空比例",
    text14: "胜率",
    text15: "7天收益率",
    text16: "30天收益率",
    text17: "总收益率",
    text18: "最大回撤",
    text19: "平均持仓时长",
    text20: "2天0时26分",
    text21: "当前跟随人数",
    text22: "历史总跟随人次",
    text23: "历史平均跟随时长",
    text24: "跟随用户总收益",
    text25: "跟单价格（30天)",
    text26: "跟单总收入",
    text27: "跟单收入余额",
    text28: "跟单管理",
    text29: "跟单持仓列表",
    text30: "请输入姓名",
    text31: "请输入手机号",
    text32: "请输入web账号",
    text33: "搜索",
    text34: "重置",
    text35: "交易品种",
    text36: "全部",
    text37: "买卖方向",
    text38: "买入",
    text39: "卖出",
    text40: "开仓类型",
    text41: "跟随开仓",
    text42: "交易状态",
    text43: "开仓日期",
    text44: "开始时间",
    text45: "结束时间",
    text46: "白标",
    text47: "跟随交易员",
    text48: "开仓单号",
    text49: "开仓时间",
    text50: "开仓价格",
    text51: "止盈",
    text52: "止损",
    text53: "浮动盈亏",
    text54: "隔夜利息",
    text55: "杠杆比例",
    text56: "占用保证金",
    text57: "跟单交易记录",
    text58: "平仓类型",
    text59: "到达平仓时间",
    text60: "风控强平",
    text61: "跟随平仓",
    text62: "用户自主平仓",
    text63: "未平仓",
    text64: "已平仓",
    text65: "平仓日期",
    text66: "平仓单号",
    text67: "平仓时间",
    text68: "平仓价格",
    text69: "平仓盈亏",
    text70: "跟随订阅记录",
    text71: "状态",
    text72: "暂停跟随",
    text73: "跟随中",
    text74: "退出跟随中",
    text75: "退出跟随",
    text76: "首次订阅",
    text77: "退出时间",
    text78: "跟单订阅费用",
    text79: "跟随天数",
    text80: "订阅时间",
    text81: "解除跟随时间",
    text82: "跟随开仓单数",
    text83: "跟随开仓手数",
    text84: "胜率",
    text85: "平均盈利",
    text86: "平均亏损",
    text87: "操作",
    text88: "跟随操作记录",
    text89: "操作记录",
    text90: "跟随操作",
    text91: "操作类型",
    text92: "解除跟随",
    text93: "开始跟随",
    text94: "操作时间",
    text95: "持仓处理",
    text96: "跟随新订单",
    text97: "保留持仓,跟随平仓,系统操作",
    text98: "资金操作",
    text99: "金额",
    text100: "跟随资金余额",
    text101: "财务管理",
    text102: "提现记录",
    text103: "提取审核中",
    text104: "转账审核中",
    text105: "提取驳回",
    text106: "转账驳回",
    text107: "完成",
    text108: "添加时间",
    text109: "提现",
    text110: "提现金额",
    text111: "申请时间",
    text112: "提现审核时间",
    text113: "转账审核时间",
    text114: "可提金额",
    text115: "全部提取",
    text116: "提款审核通过后，提取的资金将转入交易员的账号，请注意查收.",
    text117: "可提金额不足",
    text118: "提交",
    text119: "取消",
    text120: "个人信息",
    text121: "策略收益",
    text122: "分成收益",
    text123: "总分成金额",
    text124: "分成金额",
    text125: "分成比例",
    text126: "跟随时间",
    text127: "开仓订单号",
    text128: "平均盈亏",
    text129: "资金操作记录",
    text130: "资金提取",
    text131: "申请提现金额",
    text132: "接收账号类型",
    text133: "跟单总收入明细",
    text134: "跟单盈利分成",
  },
};

export default messages;
